import type { FaqQuestion } from "@/features/companyDetail/utils/getQuestions"
import type { FunctionComponent } from "react"

import { Text } from "@jobteaser/spark/components/Text"
import { Icon, ICON_SIZES } from "@jobteaser/ui-kit/dist/module/components/Icon/Icon"

import styles from "./QuestionCard.module.css"

type QuestionCardProps = {
  faqQuestion: FaqQuestion
  icon: string
}

export const QuestionCard: FunctionComponent<QuestionCardProps> = ({ faqQuestion, icon }) => {
  const { answer, question } = faqQuestion

  return (
    <li className={styles.questionCard}>
      <Icon role="graphics-symbol" size={ICON_SIZES.BIG} xlinkHref={`#${icon}`} />
      <Text variant="body1" weight="semiBold">
        {question}
      </Text>
      <Text variant="body2">{answer}</Text>
    </li>
  )
}
